export const normalizarTexto = (valor = "") =>
  valor.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();

export const apenasDigitos = (valor = "") => valor.replace(/\D/g, "");

export const formatarCNPJ = (valor = "") =>
  apenasDigitos(valor)
    .slice(0, 14)
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");

export const detectarCampo = (termo) => {
  const digitos = apenasDigitos(termo);
  if (digitos.length === 14 && digitos === termo.replace(/[.\-/]/g, "")) return "cnpj";
  if (digitos === termo.trim() && digitos.length > 0) return "id";
  return "razaoSocial";
};

